import { ErrorDisplayTypeEnum } from '@/modules/core/models/enums'
import CustomError from './CustomError'

const DEFAULT_DISPLAY_TYPE = ErrorDisplayTypeEnum.MODAL
const DEFAULT_TITLE = 'copy_error_validation_error'
const DEFAULT_MODAL_DESCRIPTION = 'copy_error_service_description'

export default class ServiceSchemaError extends CustomError {
  constructor(error: Partial<ServiceSchemaError> = {}) {
    super(error)

    this.name = this.constructor.name
    this.displayType = error.displayType ?? DEFAULT_DISPLAY_TYPE

    this.title = error?.title ?? DEFAULT_TITLE
    this.modalDescription = error?.modalDescription ?? DEFAULT_MODAL_DESCRIPTION

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
